import React, { useState } from "react";
import { IClinicImage } from "../types/clinic.types";
import { ConfirmationModal } from "./ConfirmationModal";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import CloseIcon from "@mui/icons-material/Close";
import bookUrl from "../../../../api/bookUrl";
interface Props {
  images: IClinicImage[];
  onImagesChange: (images: IClinicImage[]) => void;
}
const fileToBase64 = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result?.toString() ?? "");
    reader.onerror = (error) => reject(error);
  });
};
export const ClinicImages: React.FC<Props> = ({ images, onImagesChange }) => {
  const [selectedImage, setSelectedImage] = useState<IClinicImage | null>(
    images[0] || null
  );
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [deleteCandidate, setDeleteCandidate] = useState<string | null>(null);

  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];
      // Create a mock new image. In a real app, you'd upload this.
      const base64String = await fileToBase64(file);
      const newImage: IClinicImage = {
        id: `img_${Date.now()}`,
        imageUrl: URL.createObjectURL(file),
        url: URL.createObjectURL(file),
        alt: file.name,
        file: file,
        base64: base64String,
      };
      const newImage1: IClinicImage = {
        id: `img_${Date.now()}`,
        url: URL.createObjectURL(file),
        file: file,
        base64: base64String,
      };
      const res = await bookUrl.patch("/bookingclinic/clinic/addClinicImage", {
        images: newImage1,
      });
      console.log(res.data);
      
      onImagesChange([...images, newImage]);
      if (!selectedImage) {
        setSelectedImage(newImage);
      }
    }
  };

  const handleDelete = () => {
    if (!deleteCandidate) return;
    const newImages = images.filter((img) => img.id !== deleteCandidate);
    onImagesChange(newImages);

    // If the deleted image was the selected one, select a new one
    if (selectedImage?.id === deleteCandidate) {
      setSelectedImage(newImages[0] || null);
    }
    setDeleteCandidate(null);
  };

  return (
    <section className="page-section clinic-images">
      <div className="section-header">
        <h2>Clinic Images</h2>
        <label className="btn btn-primary">
          <UploadIcon /> Upload
          <input type="file" accept="image/*" hidden onChange={handleUpload} />
        </label>
      </div>

      {selectedImage && (
        <div
          className="main-image-view"
          onClick={() => setShowPreviewModal(true)}
        >
          <img src={selectedImage.imageUrl} alt={selectedImage.alt} />
        </div>
      )}

      <div className="thumbnail-gallery">
        {images.map((img,i) => (
          <div
            key={i}
            className={`thumbnail ${selectedImage?.id === img.id ? "active" : ""}`}
            onClick={() => setSelectedImage(img)}
          >
            <img src={img.imageUrl} alt={img.alt} />
            <button
              className="btn btn-icon delete-btn"
              onClick={(e) => {
                e.stopPropagation();
                setDeleteCandidate(img.id);
              }}
            >
              <DeleteIcon />
            </button>
          </div>
        ))}
      </div>

      {/* Full-size Image Preview Modal */}
      {showPreviewModal && selectedImage && (
        <div
          className="modal-overlay"
          onClick={() => setShowPreviewModal(false)}
        >
          <div
            className="modal-content modal-image-preview"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="btn btn-icon modal-close-btn"
              onClick={() => setShowPreviewModal(false)}
            >
              <CloseIcon />
            </button>
            <img src={selectedImage.imageUrl} alt={selectedImage.alt} />
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteCandidate && (
        <ConfirmationModal
          title="Delete Image"
          message="Are you sure you want to delete this image?"
          onConfirm={handleDelete}
          onCancel={() => setDeleteCandidate(null)}
        />
      )}
    </section>
  );
};
